// fr
export const supplierUser = {
  modal_title: "Créer un utilisateur fournisseur",
  form: {
    name: "Nom",
    email: "Email",
    validator: "Validateur",
    validator_name: "Nom du validateur",
    validator_email: "Email du validateur",
    validator_role: "Rôle du validateur",
    select_validator: "-- Sélectionnez un validateur --",
    select_role: "-- Sélectionnez un rôle --",
    create_validator: "Créer validateur",
    cancel: "Annuler",
    creating: "Création...",
    create_user: "Créer l'utilisateur",
    fill_all_fields_validator:
      "Veuillez remplir tous les champs du validateur !",
    select_or_create_validator:
      "Veuillez sélectionner ou créer un validateur !",
    user_created_success: "Utilisateur créé avec succès !",
    validator_created_success: "Validateur créé avec succès !",
    error_create_validator: "Erreur lors de la création du validateur.",
    error_create_user: "Erreur lors de la création de l'utilisateur.",
    create_new_validator: "+ Créer un nouveau validateur",
  },
};
